import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

const HelpIcon: React.SFC<HelpIconProps> = (props: HelpIconProps): JSX.Element => (
  <span className={classNames('helpIcon-container', props.className)}>
    <BenchlingIcon {...props} className="helpIcon" icon="question" />
  </span>
);

export interface HelpIconProps {
  className?: string;
  onClick?: (e: ElementMouseEvent) => void;
}

HelpIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} as any;

export default HelpIcon;
